import React from 'react';
import { Container, DateText } from './DateHeader.styled';

interface DateHeaderProps {
  dateText: string;
}

export const DateHeader: React.FC<DateHeaderProps> = ({ dateText }) => {
  return (
    <Container>
      <DateText>{dateText}</DateText>
    </Container>
  );
};

export default DateHeader;
